// extracted by mini-css-extract-plugin
module.exports = {"FeatureWrapper":"FeatureWrapper_FeatureWrapper__15H6u"};